<app-card cardTitle="{{'changeBranch' | translate}}" [padding]="20">
    <ng-template #headerOptionsTemplate>
        <a href="javascript:" class="text-muted" mat-dialog-close>
            <i class="ti ti-x f-20"></i>
        </a>
    </ng-template>
    <div style="height: 150px;justify-content: space-between;display: flex;">
        <mat-form-field appearance="outline" style="height: 50px;">
            <mat-label>{{'branch' | translate}}</mat-label>
            <mat-select [(ngModel)]="selectedBranch" name="exOption" (selectionChange)="branchSelect($event.value)">
                @for (branch of branchsData; track branch) {
                <mat-option [value]="branch.id">{{currentLang === 'ar' ? branch.brancharaname :
                    branch.branchlatname}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <button mat-flat-button color="primary" class="m-r-10" mat-dialog-close>{{'ok' |
            translate}}</button>
    </div>
</app-card>